import Entity from './entity';
import { computed } from '@ember/object';
import { hash, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import uriEncodeAttributes from './../../lib/computed-properties/uri-encode-attributes';
import Constants from '@intercom/embercom-composer/lib/constants';
export default Entity.extend({
  precedence: 3,
  type: 'anchor',
  tagName: 'a',
  hasEditor: true,
  encodedHref: uriEncodeAttributes('href'),
  htmlEscapedHref: htmlEscape('encodedHref'),
  copySafeHrefAttribute: Constants.COPY_SAFE_HREF_ATTRIBUTE,
  attributesToCopy: ['startIndex', 'endIndex', 'href'],
  options: hash('href'),
  additionalAttributes: computed('htmlEscapedHref', 'copySafeHrefAttribute', function () {
    return `href="${this.htmlEscapedHref}" ${this.copySafeHrefAttribute}="${this.htmlEscapedHref}"`;
  }),
  serializedAttributes: computed('htmlEscapedHref', function () {
    return `href="${this.htmlEscapedHref}"`;
  }),
  cleanData() {
    this.cleanUrl('href');
  },
  isSelectedForEdit(selection) {
    if (selection.get('isZeroWidth')) {
      let caretIndex = selection.get('endPositionIndex');
      if (caretIndex >= this.get('startIndex') && caretIndex <= this.get('endIndex')) {
        return true;
      }
    }
    return false;
  }
}).reopenClass({
  tagName: 'A'
});